import React from 'react';

// Filet de sécurité global : sans ceci, la moindre exception de rendu React
// (n'importe où dans l'app) fait disparaître toute la page sans aucun message,
// y compris dans la console utilisateur. D'où l'affichage du message technique
// ci-dessous plutôt qu'un simple écran blanc.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Erreur non gérée capturée par ErrorBoundary:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div style={{
          margin: '60px auto',
          maxWidth: '700px',
          padding: '24px 28px',
          border: '1px solid #f3c2c2',
          borderRadius: '10px',
          background: '#fdf2f2',
          color: '#7a1f1f',
        }}>
          <h2 style={{ marginTop: 0 }}>Une erreur est survenue</h2>
          <p>
            L'application a rencontré une erreur inattendue et n'a pas pu afficher cette page.
            Le message technique ci-dessous peut aider à identifier la cause :
          </p>
          <pre style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            background: '#fff',
            border: '1px solid #f3c2c2',
            borderRadius: '6px',
            padding: '12px',
            fontSize: '0.85rem',
          }}>
            {this.state.error?.message || String(this.state.error)}
          </pre>
          <button
            onClick={this.handleReload}
            style={{
              marginTop: '12px',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '6px',
              background: '#dc2626',
              color: '#fff',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Recharger la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
